<template>
  <div class="buy-card" v-title data-title="购买">
    <header>

    </header>
    <section>
      <!-- 服务类型 -->
      <div class="card-type">
        <div class="box1">
          <p>
            {{card_msg.name}}
          </p>
          <p>
            加入会员获得推广资格
          </p>
        </div>
        <p class="p1">
          ￥{{card_msg.pcate}}
        </p>
      </div>
      <div class="personal-details">
        <div class="msg">
          <p>
            所在城市  
          </p>
          <p>
            <input type="text" placeholder="选择" readonly v-model="userlist.address" @click="showAddressChuang" style="width: 4.5rem">
          </p>
        </div>
      </div>
      <!-- 支付按钮 -->
      <div class="buy-btn" @click="payBtn">
        立即支付
      </div>
      <div class="img999">
        <img src="../../assets/images/card-img/buy-card-img/1.png" alt="">
      </div>
    </section>
    <van-popup v-model="showAddress" position="bottom" :style="{ height: '40%' }">
      <van-area
        :area-list="areaList"
        :value="areaCode"
        title="请选择你所在的城市"
        @confirm="sure"
        @cancel="exit"
        :columns-num="1"
        @change="change"
      />
    </van-popup>
  </div>
</template>
<script>

import Vue from 'vue';
import addressList from '../../../public/addressList/area1'
import { ActionSheet, Area, Popup, Toast} from 'vant';
Vue.use(ActionSheet);
Vue.use(Area);
Vue.use(Popup);

export default {
  data(){
    return{
      userlist: [], // 现住址
      showAddress: false, // 先住址弹窗
      areaList: addressList, // 选中省市区
      areaCode:'', // 选中省市区的code 
      real_name:'' , // 姓名
      id_card: '' , // 身份证
      address_code: '', // 地区code
      card_msg: [],
      card_id: ''
    }
  },
  created(){
    this.card_id = this.$route.query.id
    // console.log(this.card_id)
    this.$axios.get(this.domain.url+'/api/card/index/detail?id=' + this.card_id).then((res) =>{
      // console.log(res)
      this.card_msg = res.data.data
    })
  },
  methods:{
    // 收货地址
    showAddressChuang(){
      this.showAddress = true
    },
    // 选择地址完成按钮
    sure(val){
      this.showAddress = false
      // console.log(val)
      this.address_code = val[0].code.slice(4,6)
      // console.log(this.address_code)
      this.userlist.address = val[0].name
      // console.log(this.userlist)
    },
    // 选择地址取消按钮
    exit(){
      this.showAddress = false
    },
    change(event){
      // console.log(event)
    },
    payBtn(){
      if(!this.address_code){
        Toast("请选择您所在的城市")
      }else{
        let pay_url = "http://members.kfm666666.net/api/pay/index/wxpay/?type=" + "1" + "&gid=" + this.card_id + "&city_no=" + this.address_code
        // console.log(pay_url)
        window.location.replace(pay_url)
      }
    }
  },
}
</script>
<style lang="less" scoped>
  .buy-card{
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    section{
      width: 100%;
      // height: 100%;
      flex: 1;
      // 服务类型
      .card-type{
        width: 100%;
        height: 3.11rem;
        background-image: url(../../assets/images/card-img/buy-card-img/2.png);
        background-size: 100% 3.11rem;
        overflow: hidden;
        .box1{
          margin-left: 1.1rem;
          float: left;
          p{
            &:first-child{     
              font-size: 0.36rem;
              font-family: PingFang SC;
              font-weight: bold;
              color: #744B16;
              margin-top: 1.6rem;
            }
            &:last-child{
              font-size: 0.24rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #744B16;
              margin-top: .19rem;
            }
          }
        }
        .p1{
          float: right;
          margin-top: 2.1rem;
          margin-right: .89rem;
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #744B16;
        }
      }
      .personal-details{
        margin-top: 1.21rem;
        .msg{
          width: 6.32rem;
          height: 0.88rem;
          margin: 0 auto;
          border-bottom: .01rem black dashed;
          margin-bottom: .21rem;
          p{
            &:first-child{
              float: left;
              line-height: .88rem;
              margin-left: .26rem;
              font-size: 0.26rem;
              font-family: PingFang SC;
              font-weight: bold;
              color: #0C0C0C;
            }
            &:last-child{
              float: right;
              margin-right: .26rem;
              display: flex;
              height: .88rem;
              align-items: center;
              input{
                font-size:0.28rem;
                font-family:PingFang SC;
                font-weight:400;
                color:rgba(153,153,153,1);
                text-align: right;
                border: none;
                outline: none;
              }
            }
          }
        }
      }
      // 购买按钮
      .buy-btn{
        width: 6.7rem;
        height: .9rem;
        margin: 0 auto;
        background-image: url(../../assets/images/card-img/buy-card-img/3.png);
        background-size: 6.7rem .9rem;
        font-size: 0.34rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #724913;
        text-align: center;
        line-height: .88rem;
        margin-top: 1.34rem;
      }
      .img999{
        width: 3.89rem;
        height: .78rem;
        margin: 0 auto;
        position: absolute;
        left: 1.8rem;
        bottom: .33rem;
        img{
          width: 3.89rem;
          height: .78rem;
        }
      }
    }
    .van-picker__cancel, .van-picker__confirm{
      color: red;
    }
  }
</style>